import { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Form, Row, InputGroup } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import { CiEdit, CiFilter, CiTrash } from 'react-icons/ci';
import "react-datepicker/dist/react-datepicker.css";
import { BiSearch } from 'react-icons/bi';
import { RiResetLeftFill } from 'react-icons/ri';
import { useLocation, useNavigate } from 'react-router-dom';
import { TbListDetails } from 'react-icons/tb';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import Swal from 'sweetalert2';

const ProductDetailTable = ({ listProductCategory, tittle, onDelete }) => {

    const navigate = useNavigate();

    const location = useLocation();
    const receivedData = location.state;

    // console.log(receivedData?.row)

    // const [selectedRows, setSelectedRows] = useState(false);
    // const [toggledClearRows, setToggleClearRows] = useState(false);

    const [filteredProducts, setFilteredProducts] = useState(listProductCategory);

    const [name, setName] = useState("");

    const handleFiltersChange = () => {
        const filtered = listProductCategory.filter((productDetail) => {
            const nameMatch = productDetail.name.toLowerCase().includes(name.toLowerCase());

            return nameMatch;
        });

        setFilteredProducts(filtered);
    };

    const resetFilters = () => {
        setName("");
        setFilteredProducts(listProductCategory);
    };

    const handleNavigateProduct = () => {
        navigate(-1)
    }

    const handleDeleteListCategoriesProductDetail = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to delete this item?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                onDelete(id);// Call delete function if confirmed
                Swal.fire("Deleted!", "The item has been deleted.", "success");
            }
        });
    }

    const columns = [
        {
            name: 'No.',  // Serial Number Column
            selector: (row, index) => index + 1,
            sortable: true,
            width: '60px',  // Optional: Adjusts the width
        },
        { name: 'Name', selector: row => row.name, sortable: true },
        // {
        //     name: 'Active', selector: row =>
        //         row.active === 1 ? (
        //             <span style={{ color: 'green' }}>
        //                 <FaCheckCircle /> Active
        //             </span>
        //         ) : (
        //             <span style={{ color: 'red' }}>
        //                 <FaTimesCircle /> Inactive
        //             </span>
        //         )
        //     , sortable: true
        // },
        {
            name: 'Actions',
            cell: row => (
                <>
                    <Button Tooltip={"Detail"} variant="outline-danger" className="m-1"
                        onClick={() => handleDeleteListCategoriesProductDetail(row.id)}
                    >
                        <CiTrash size={30} />
                    </Button>
                </>
            ),
        },
    ];

    return (
        <>
            {/* {selectedRows.length > 0 && (
                <Button Tooltip={"test"} variant="outline-danger" className="me-1 mb-2">
                    <CiTrash size={32} />
                </Button>
            )} */}

            <Card className="mb-2">
                <Card.Body>
                    <Form>
                        <Row className="align-items-center">
                            {/* Name Filter */}
                            <Form.Label>
                                <span style={{ fontSize: 15 }}>List Product Category</span><span style={{ color: 'red' }}>*</span>{' '}
                                <span style={{ fontSize: 12, cursor:'pointer'}} onClick={handleNavigateProduct}>{tittle?.name}</span>
                            </Form.Label>
                            <Col xs={12} sm={6}>
                                <InputGroup>
                                    <Form.Control
                                        type="text"
                                        placeholder="Search name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                    <Button variant="outline-secondary"
                                        onClick={handleFiltersChange}
                                    >
                                        <CiFilter /> Filters
                                    </Button>
                                    <Button variant="outline-info"
                                        onClick={resetFilters}
                                    >
                                        <RiResetLeftFill /> Refresh
                                    </Button>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Form>
                    <DataTable
                        title="List Categories Product"
                        columns={columns}
                        data={filteredProducts.length > 0 ? filteredProducts : listProductCategory}
                        pagination
                        responsive
                    // highlightOnHover
                    // expandableRows
                    // expandableRowsComponent={ProductDetailCategoriesTableExpand}
                    />
                </Card.Body>
            </Card>
        </>
    )
};

export default ProductDetailTable;